<script>
export default {
  props: {
    goodsId: {
      type: String,
      required: true
    }
  },
  computed: {
    index  () {
      function indexOf (array, key, value) {
        if (!Array.isArray(array)) {
          return false
        }
        for (let i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return i
          }
        }
        return false
      }
      return indexOf(this.docs.goods, 'id', this.goodsId)
    },
    goods () {
      return this.docs.goods[this.index]
    },
    goodsList () {
      return this.docs.goods
    },
    next () {
      const item = this.docs.goods[this.index + 1]
      return item ? item.id : false
    },
    prev () {
      const item = this.docs.goods[this.index - 1]
      return item ? item.id : false
    }
  }
}
</script>

<template>
  <div class="gp-goods-article transition-item">
    <article>
      <div>
        <h1 class="has-text-weight-bold has-text-align-center">{{ goods.name }}</h1>
        <figure>
          <img :src="goods.image">
        </figure>
        <div class="description is-size-4 is-size-5-mobile">
          <p>{{ goods.description }}</p>
        </div>
      </div>
      <section class="detail">
        <h1 class="is-size-3 is-size-5-mobile has-text-weight-bold has-text-align-center-mobile">商品詳細</h1>
        <dl>
          <template v-for="(value, name) in goods.spec">
            <dt
              class="has-text-weight-bold is-size-4 is-size-6-mobile"
              :key="name"
            >
              {{ name }}
            </dt>
            <dd
              class="is-size-4 is-size-6-mobile"
              :key="value"
              v-html="value"
            ></dd>
          </template>
          <dt
            class="has-text-weight-bold is-size-4 is-size-6-mobile"
            key="url"
          >URL</dt>
          <dd
            class="is-size-4 is-size-6-mobile"
            :key="goods.url"
          >
            <a
              target="_blank"
              rel="noopener"
              :href="goods.url"
            >
              {{ goods.url }}
            </a>
          </dd>
        </dl>
      </section>
    </article>
    <nav>
      <div class="level is-mobile is-size-2 has-text-weight-bold is-family-oswald">
        <div :class="{disable: !prev}">
          <router-link :to="{name: 'goods-article', params: {goodsId: prev}}">
            <span :class="{link: prev}">PREV</span>
          </router-link>
        </div>
        <div>
          <router-link :to="{name: 'goods'}">
            <span class="link">LIST</span>
          </router-link>
        </div>
        <div :class="{disable: !next}">
          <router-link :to="{name: 'goods-article', params: {goodsId: next}}">
            <span :class="{link: next}">NEXT</span>
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.gp-goods-article {
  nav {
    width: 18rem;
    margin: auto;
  }
  article {
    @include is-mobile {
      padding: 0 1rem;
    }
    h1 {
      @include is-mobile {
        font-size: 1.875rem;
        line-height: 35px;
        margin-bottom: 1.5rem;
      }
      @include is-not-mobile {
        font-size: 2.5rem;
        margin-bottom: 2rem;
      }
    }
    figure {
      max-width: 40rem;
      max-height: 30rem;
      margin: auto;
      text-align: center;
      @include is-mobile {
        max-width: 100%;
        max-height: 16rem;
      }
      img {
        width: auto;
        height: auto;
        max-width: 40rem;
        max-height: 30rem;
        @include is-mobile {
          max-width: 100%;
          max-height: 16rem;
        }
      }
    }
    .description {
      @include is-mobile {
        margin: 1rem 0;
        padding: 0 .5rem
      }
      @include is-not-mobile {
        margin: 2rem 0;
        padding: 0 1rem;
      }
    }
    .detail {
      margin-bottom: 4rem;
      h1 {
        color: $pink;
        background-color: $black;
        padding: .25rem 1rem;
        margin-bottom: 0;
      }
      dl {
        background-color: $white-transparent;
        padding: .5rem;
        @include is-not-mobile {
          padding: .75rem 1rem;
        }
        dd {
          word-break: break-all;
          @include is-mobile {
            margin-left: 5rem;
            margin-top: -21px;
            &:not(:last-child) {
              margin-bottom: .75rem;
            }
          }
          @include is-not-mobile {
            margin-left: 8rem;
            margin-top: -25px;
            &:not(:last-child) {
              margin-bottom: .75rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/goods/goods-article.vue